const STATE_LABEL = {
    active: 'In progress',
    approved: 'Approved',
    rejected: 'Rejected',
    removed: 'Removed',
    warning: 'Approved with warnings'
};
export const statusMapper = (status, success, warnings) => {
    let state = 'active';
    if (status === 'removed') {
        state = 'removed';
    }
    else if (status === 'completed' && !success) {
        state = 'rejected';
    }
    else if (status === 'completed' && success && warnings) {
        state = 'warning';
    }
    else if (status === 'completed' && success) {
        state = 'approved';
    }
    return { state, label: STATE_LABEL[state] };
};
